<!--text
Use ngx-loading-bar/http-client when load this page.
-->
<ngx-loading-bar [color]="'white'"></ngx-loading-bar>
<!-- / -->

<main class="w-full px-4">
  <div class="mx-auto max-w-7xl">
    <div>
      <!-- Breadcrumbs -->
      <nav class="flex mt-12" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
          <li>
            <div>
              <a [routerLink]="['/']" class="text-gray-400 hover:text-pink-800">
                <svg class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clip-rule="evenodd" />
                </svg>
                <span class="sr-only">Início</span>
              </a>
            </div>
          </li>

          <li>
            <div class="flex items-center">
              <svg class="h-5 w-5 flex-shrink-0 text-pink-800" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <a class="ml-4 text-sm font-medium text-gray-500 hover:text-pink-800" aria-current="page">Clube Gê</a>
            </div>
          </li>
        </ol>
      </nav>
      <div class="py-20">
        <div class="my-6">
          <div class="flex justify-center items-center mb-4">
            <img src="/assets/images/subscription/logo-clube-ge.webp" alt="Logo Clube Gê" class="w-full sm:w-[45%]" />
          </div>
          <div class="flex flex-col space-y-2 pt-8">
            <p class="text-2xl font-bold tracking-tight text-pink-900">+ Praticidade e Economia para suas compras!</p>
          </div>
        </div>

        <div class="mx-4 sm:mx-16 my-6">
          <ol class="relative border-l border-gray-200 items-center">
            <li class="mb-10 ml-8">
              <span class="absolute flex items-center justify-center h-8 w-8 bg-amber-100 rounded-full -left-4 ring-2 ring-white">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </span>
              <h3 class="flex items-center mb-1 text-lg font-semibold text-pink-800">Escolha os produtos</h3>
              <p class="mb-4 text-sm font-normal text-gray-700">Sabe aqueles itens de limpeza e cuidados com a roupa que não podem faltar na sua casa? Selecione tudo aqui no <strong>Clube Gê</strong> e deixe que a gente fará as entregas aí na sua casa. Mais conforto e praticidade para você.</p>
            </li>
            <li class="mb-10 ml-8">
              <span class="absolute flex items-center justify-center w-8 h-8 bg-amber-100 rounded-full -left-4 ring-2 ring-white">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </span>
              <h3 class="flex items-center mb-1 text-lg font-semibold text-pink-800">Agende a entrega e programe cestas mensais</h3>
              <p class="mb-4 text-sm font-normal text-gray-700">
                Aqui no <strong>Clube Gê</strong> você pode escolher qual a melhor data mensal para receber a sua cesta. Escolha o melhor dia da semana na melhor semana do mês para receber os produtos. Exemplo: escolhendo a primeira segunda-feira do mês, as próximas cestas serão enviadas todas as primeiras segundas-feiras dos meses subsequentes.
              </p>
            </li>
            <li class="ml-8">
              <span class="absolute flex items-center justify-center w-8 h-8 bg-amber-100 rounded-full -left-4 ring-2 ring-white">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </span>
              <h3 class="mb-1 text-lg font-semibold text-pink-800">Receba seus kits em casa todo mês</h3>
              <p class="text-sm font-normal text-gray-700">
                Você vai receber no conforto de sua casa a cesta de limpeza que montou no <strong>Clube Gê</strong> e assim ficar desencanada(o) se vai ter produtos de limpeza sempre que precisar. Além de poupar tempo, gasolina e disposição para carregar os itens do mercado até a sua casa. Deixa com a gente toda essa parte inconveniente e aproveite o tempo
                com quem você ama e curta mais momentos de lazer.
              </p>
            </li>
          </ol>
        </div>

        <div class="mx-4 sm:mx-16 my-8">
          <div class="flex space-x-2 pt-8 items-start">
            <p class="text-2xl font-bold tracking-tight text-pink-900">Calcula Gê</p>
            <div class="w-fit rounded-lg py-1 px-2 text-xs font-medium ring-1 ring-inset text-orange-700 bg-orange-50 ring-orange-600/20">Novidade</div>
          </div>
          <p class="text-sm font-normal text-gray-700">
            Descubra a solução perfeita para suas necessidades mensais de limpeza e lavanderia com a <strong>Calcula Gê!</strong> Chega de dúvidas sobre o que sua casa precisa. Nós estamos aqui para ajudar! Basta nos informar sua demanda e sua rotina de cuidados, e iremos sugerir a cesta ideal para você. Com a Calcula Gê, você economiza tempo e dinheiro,
            garantindo que sua casa esteja sempre impecável. Não perca mais tempo, venha conferir!
          </p>
          <div class="mt-4">
            <a href="https://gtexbrasil.postclickmarketing.com/calcula-ge" class="rounded-md bg-pink-800 text-sm py-2 px-3 font-semibold text-white shadow-sm hover:bg-pink-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-800">Calcular</a>
          </div>
        </div>

        <div class="py-12">
          <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mx-auto max-w-2xl lg:mx-0">
              <h2 class="text-2xl font-bold tracking-tight text-pink-800">Monte seu Kit</h2>
            </div>
            <ul role="list" class="mx-auto mt-6 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
              <ng-container *ngIf="kits?.total > 0; else loading">
                <ng-container *ngFor="let kit of kits?.data">
                  <div class="border-t border-b border-gray-200 bg-white shadow-sm sm:rounded-lg sm:shadow-none sm:border-l sm:border-r">
                    <li class="p-6">
                      <div class="flex justify-center">
                        <img class="overflow-hidden h-36 w-64 object-contain object-center lg:max-w-[75%]" src="{{kit.img_spotlight_banner}}" alt="{{kit.name}}" />
                      </div>
                      <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight text-amber-400">{{kit.name}}</h3>
                      <p class="text-sm text-gray-600">{{kit.description}}</p>
                      <div class="flex gap-x-6 mt-5">
                        <button [routerLink]="['/subscription/kit/'+kit.id+'/view']" type="submit" class="rounded-md bg-pink-800 py-2 px-3 text-sm font-semibold text-white shadow-sm hover:bg-pink-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-800">Conhecer Kit</button>
                      </div>
                    </li>
                  </div>
                </ng-container>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<ng-template #loading>
  <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center w-full">
    <div class="flex items-center justify-center w-full h-64 bg-gray-300 rounded"></div>
  </div>
  <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center w-full">
    <div class="flex items-center justify-center w-full h-64 bg-gray-300 rounded"></div>
  </div>
  <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center w-full">
    <div class="flex items-center justify-center w-full h-64 bg-gray-300 rounded"></div>
  </div>
</ng-template>
